import { styled } from "../../../../styles";

export const TitleContainer = styled("div", {
  display: "flex",
  alignItems: "center",
});
